import React, { useEffect, useRef } from "react";

const Layout10 = ({ data }) => {
    const {
        video,
        brand,
        qr,
        compareImages,
        canvas,
        leftCompareText,
        rightCompareText,
    } = data;

    const videoRef = useRef(null);

    const textColor = canvas?.textColor || "#ffffff";
    const qrTextColor = canvas?.qrTextColor || "#ffffff";

    /*
     * Keep video playing
     */
    useEffect(() => {
        if (!videoRef.current) return;

        const videoElement = videoRef.current;

        videoElement.play().catch(() => { });
    }, [video?.url]);

    return (
        <>
            {/* =========================================
                COMPONENT LEVEL CSS
            ========================================= */}
            <style>
                {`
                    @keyframes layout10FadeIn {
                        from {
                            opacity: 0;
                        }

                        to {
                            opacity: 1;
                        }
                    }

                    .layout10-element {
                        animation: layout10FadeIn 500ms ease-out;
                    }
                `}
            </style>

            {/* =========================================
                MAIN CANVAS
            ========================================= */}
            <div
                className="
                    relative
                    w-full
                    h-full
                    overflow-hidden
                    bg-black
                    bg-cover
                    bg-center
                    bg-no-repeat
                "
                style={{
                    backgroundImage: canvas?.backgroundImageUrl
                        ? `url(${canvas.backgroundImageUrl})`
                        : undefined,
                }}
            >

                {/* =========================================
                    VIDEO SECTION
                ========================================= */}
                <div
                    className="
                        absolute
                        left-[2.8%]
                        top-[7%]
                        w-[56%]
                        h-[60%]
                        overflow-hidden
                        border-[3px]
                        border-white
                    "
                >
                    {video?.url && (
                        <video
                            ref={videoRef}
                            src={video.url}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="
                                w-full
                                h-full
                                object-cover
                            "
                        />
                    )}
                </div>


                {/* =========================================
                    LEFT COMPARISON TEXT
                    Positioned between video and batteries
                ========================================= */}
                <div
                    className="
                        layout10-element
                        absolute
                        left-[50%]
                        top-[73%]
                        w-[15%]
                        text-start
                        text-md
                        font-medium
                        leading-tight
                    "
                    style={{
                        color: textColor,
                    }}
                >
                    {leftCompareText}
                </div>


                {/* =========================================
                    QR SECTION
                ========================================= */}
                <div
                    className="
                        absolute
                        left-[6%]
                        bottom-[11%]
                        w-[40%]
                        h-[19%]
                        flex
                        items-center
                        gap-8
                    "
                >
                    {/* QR IMAGE */}
                    {qr?.imageUrl && (
                        <img
                            src={qr.imageUrl}
                            alt="QR Code"
                            className="
                                w-[9rem]
                                h-[9rem]
                                object-contain
                                shrink-0
                            "
                        />
                    )}

                    {/* QR TEXT */}
                    <div
                        className="
                            text-3xl
                            font-bold
                            leading-tight
                            w-[32%]
                        "
                        style={{
                            color: qrTextColor,
                        }}
                    >
                        {qr?.qrText}
                    </div>
                </div>


                {/* =========================================
                    RIGHT SIDE COMPARISON
                ========================================= */}
                <div
                    className="
                        absolute
                        right-[2%]
                        top-[6%]
                        w-[35%]
                        h-[96%]
                    "
                >

                    {/* =====================================
                        MAIN BRAND LOGO
                    ===================================== */}
                    <div
                        className="
                            absolute
                            top-0
                            left-0
                            w-full
                            flex
                            items-start
                            justify-center
                        "
                    >
                        {brand?.logoUrl && (
                            <img
                                src={brand.logoUrl}
                                alt="Brand"
                                className="
                                    max-w-[75%]
                                    max-h-full
                                    object-contain
                                "
                            />
                        )}
                    </div>


                    {/* =====================================
                        VARIANT LOGO
                    ===================================== */}
                    {brand?.variantLogoUrl && (
                        <div
                            className="
                                absolute
                                top-[10%]
                                left-0
                                w-full
                                flex
                                items-center
                                justify-center
                            "
                        >
                            <img
                                src={brand.variantLogoUrl}
                                alt="Variant"
                                className="
                                    max-w-[55%]
                                    max-h-full
                                    object-contain
                                "
                            />
                        </div>
                    )}


                    {/* =====================================
                        LEFT BATTERY IMAGE
                    ===================================== */}
                    {compareImages?.leftImage && (
                        <img
                            src={compareImages.leftImage}
                            alt="Left comparison"
                            className="
                                layout10-element
                                absolute
                                left-[3%]
                                bottom-[5%]
                                w-[36%]
                                h-[65%]
                                object-cover
                            "
                        />
                    )}


                    {/* =====================================
                        RIGHT BATTERY IMAGE
                    ===================================== */}
                    {compareImages?.rightImage && (
                        <img
                            src={compareImages.rightImage}
                            alt="Right comparison"
                            className="
                                layout10-element
                                absolute
                                right-[0%]
                                bottom-[5%]
                                w-[36%]
                                h-[65%]
                                object-cover
                            "
                        />
                    )}


                    {/* =====================================
                        VS
                    ===================================== */}
                    <div
                        className="
                            absolute
                            left-1/2
                            bottom-[27%]
                            -translate-x-1/2
                            text-5xl
                            font-bold
                            text-white
                        "
                    >
                        VS
                    </div>


                    {/* =====================================
                        RIGHT COMPARISON TEXT
                    ===================================== */}
                    <div
                        className="
                            absolute
                            left-[51%]
                            bottom-[20%]
                            w-[34%]
                            text-center
                            text-md
                            font-medium
                            leading-tight
                            -translate-x-1/2
                        "
                        style={{
                            color: textColor,
                        }}
                    >
                        {rightCompareText}
                    </div>

                </div>

            </div>
        </>
    );
};

export default Layout10;